import { Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable({
  providedIn: 'root',
})
export class GtmWrapperService {
  constructor(private gtmService: GoogleTagManagerService) {}

  pushTag(item: Record<string, string | number | boolean | undefined>): void {
    this.gtmService.pushTag(item).catch(() => {});
  }
}
